/**
 * Distinguishes "this screen just became inaccessible because the user switched roles"
 * (RequireAccess should quietly land them on their new home page) from "the user directly
 * navigated/deep-linked to a page this role never had access to" (RequireAccess should show
 * /unauthorized). Set right before a switch triggers a permission refresh.
 *
 * Deliberately a non-destructive time window rather than a one-shot "consume and clear" flag:
 * RequireAccess can legitimately re-evaluate more than once for the same permission change
 * (React re-rendering the same update), and clearing the flag on the first read made later
 * reads of that SAME switch wrongly fall through to /unauthorized.
 *
 * The window must comfortably outlast the permission re-fetch that follows a switch
 * (ensureRbacSnapshot's role-permissions call), not just a render retry — a slow network
 * must not let the flag expire before the refreshed state actually lands.
 */
const RECENT_SWITCH_WINDOW_MS = 5000;

let switchedAt = 0;

export function markRoleJustSwitched(): void {
  switchedAt = Date.now();
}

export function wasRoleJustSwitched(): boolean {
  return Date.now() - switchedAt < RECENT_SWITCH_WINDOW_MS;
}
